import SolutionList from "./components/SolutionList";
import styles from "./index.module.less";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { Flex } from "antd";
import Navs from "./components/SolutionList/Navs";
import boxActiveImg from "./imgs/box_active.png";
import boxImg from "./imgs/box.png";
import P1Content from "@/components/P1Content";
import { isMobile } from "@/utils";
import MobileSolutions from "./mobile";
import data from "./data";
const { solutionList } = data;
const anchors = [...new Set(solutionList.map((item) => item.anchor))];
const fields = anchors.map((item) => {
  const icon = new URL(`./imgs/${item}.svg`, import.meta.url).href;
  return {
    anchor: item,
    icon: icon,
  };
});
const Solutions = () => {
  const swiperRef = useRef<any>(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    swiperRef.current = new window.Swiper(".fieldSwiper", {
      loop: true,
      slidesPerView: "auto",
      // loopedSlides: 7,
      initialSlide: 0,
      centeredSlides: true,
      slideToClickedSlide: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        slideChangeTransitionStart: (swiper: any) => {
          setIndex(swiper.realIndex);
        },
      },
    });
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("title")) {
      setTimeout(() => {
        document
          .querySelector('[title="' + searchParams.get("title") + '"]')
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 0);
    }
  }, []);
  const [list, setList] = useState([...fields, ...fields, ...fields]);
  useEffect(() => {
    // 当页面滚动到第二组时，出现回到顶部按钮
    const handleScroll = () => {
      const secondSectionRect = document
        .getElementById(`solution-${anchors[0]}`)
        ?.getBoundingClientRect();
      const backToTopButton = document.querySelector(
        `.${styles.p2_back_top}`
      ) as any;
      if (backToTopButton && secondSectionRect) {
        const secondSectionRectCenter =
          secondSectionRect.top + window.scrollY + secondSectionRect.height / 2;
        if (
          window.scrollY + window.innerHeight / 2 >=
          secondSectionRectCenter
        ) {
          backToTopButton.style.display = "block";
        } else {
          backToTopButton.style.display = "none";
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    // 清理事件监听器
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [activeAnchor, setActiveAnchor] = useState("");
  useEffect(() => {
    // 监听滚动事件，更新activeAnchor
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      anchors.forEach((item) => {
        const elements = document.querySelectorAll(`[id^=solution-${item}]`);
        elements.forEach((element) => {
          const rect = element.getBoundingClientRect();
          // 判断元素的中心出现在视口中间时，设置activeAnchor
          const elementCenter = rect.top + window.scrollY + rect.height / 2;
          if (
            elementCenter >= scrollPosition - 200 &&
            elementCenter <= scrollPosition + 200
          ) {
            setActiveAnchor(item);
          }
        });
      });
    };
    window.addEventListener("wheel", handleScroll);
    // 移动端监听
    window.addEventListener("touchmove", handleScroll);
    // 清理事件监听器
    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("touchmove", handleScroll);
    };
  }, []);
  return (
    <div className={styles.page}>
      <div className={styles.p1}>
        <P1Content
          title="行业案例"
          subtitle="AI赋能千行百业，引领企业智变图景"
          style={{
            marginBottom: "2.83rem",
          }}
        />
        <div className={styles.swiper_container}>
          <div className="swiper fieldSwiper">
            <div className="swiper-wrapper">
              {list.map((field, i) => (
                <div
                  key={i}
                  className={classNames(styles.fieldCard, "swiper-slide", {
                    [styles.active]: index === i,
                  })}
                >
                  <Flex align="center" justify="center" vertical>
                    <div className={styles.fieldCardIconBox}>
                      <img className={styles.fieldCardSvg} src={field.icon} />
                      <img
                        className={styles.fieldCardIcon}
                        src={
                          field.anchor === list[index].anchor
                            ? boxActiveImg
                            : boxImg
                        }
                      />
                    </div>
                    <div className={styles.fieldCardTitle}>{field.anchor}</div>
                  </Flex>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.p2} id="p2">
        <div className={styles.solution_list_navs}>
          <Navs
            anchors={anchors}
            active={activeAnchor}
            onClick={(anchor) => {
              document
                .querySelector(`.${styles.solution_list_navs} #nav-${anchor}`)
                ?.scrollIntoView({ behavior: "smooth", block: "center" });
              document
                .querySelector(`#solution-${anchor}`)
                ?.scrollIntoView({ behavior: "smooth", block: "center" });
              setActiveAnchor(anchor);
            }}
          />
        </div>
        <div className={styles.solution_list_content}>
          <SolutionList />
        </div>
        <div
          className={styles.p2_back_top}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        ></div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileSolutions : Solutions;
